export class EncodingUtils {
    static componentToHex(c: any) {
        var hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    }

    static ensureHexOnly(str: string){
        if(str.startsWith("0x"))
            return str.substring(2);
        return str;
    }

    static hexToDecimal(hex: string): number {
        const n = parseInt(hex, 16);
        return n;
    }

    static hexStringToUintArray(hexString: string = ""): Uint8ClampedArray {
        const array = Uint8ClampedArray.from(Buffer.from(hexString, 'hex'));
        return array;
    }
    static hexStringToHexArray(hexString: string = ""): Array<string> {
        let array: Array<string> = [];
        for (let c = 0; c < hexString.length; c += 2){
            array.push(hexString.substring(c, c + 2));
        }
        return array;
    }
}
//eth address: hex_len=40: 6edc8eb070e3306a7b3b7195d48af6fc9099032c
//public key: hex_len=128: 1d1fae26d1429b91c41791f969259f6f6d9d66b3e2c6305980e9b532d03aa183f4f82db3e36d861e83b44bbd83e0eb1aa05def093fb76e0e8098af51b900181b